import {TableSelectionInterface} from './table-selection.interface';
import {Directive, HostListener} from '@angular/core';
/* tslint:disable:directive-class-suffix */
@Directive()
export abstract class TableSelectionAbstract implements TableSelectionInterface {
  nzScrollItem: any;
  dxGridHeight: any;
  gridHeight = '';
  gridWidth = '';

  isAllDisplayDataChecked = false;
  isOperating = false;
  isIndeterminate = false;
  listOfDisplayData: any[] = [];
  listOfAllData: any[] = [];
  prop: string;

  mapOfCheckedId: { [key: number]: boolean } = {};
  numberOfChecked = 0;
  numberRecord = 0;

  constructor(
    prop: string
  ) {
    this.prop = prop;
  }

  initTableHeight(gridWidth = 1200) {
    setTimeout(() => {
      let filterTop: any = document.getElementsByClassName('div-action-top')[0];
      if (!filterTop) {
        filterTop = document.getElementsByClassName('page-toolbar')[0];
      }

      let filterHeight = filterTop ? filterTop.clientHeight : 0;

      const filterBottom: any = document.getElementsByClassName('div-action-bottom')[0];
      filterHeight += filterBottom ? filterBottom.clientHeight : 0;

      let gridHeight = window.innerHeight - 65 - 45 - 50 - filterHeight;

      this.gridHeight = gridHeight + 'px';
      this.gridWidth = gridWidth + 'px';

      if (gridWidth === 0) {
        this.nzScrollItem = {
          y: (gridHeight - 10) + 'px'
        };
      } else {
        this.nzScrollItem = {
          x: gridWidth + 'px',
          y: (gridHeight - 10) + 'px'
        };
      }

      const gridFooter: any = document.getElementsByClassName('grid-footer')[0];
      if (gridFooter) {
        gridHeight = gridHeight - gridFooter.clientHeight;
      }

      const divAlert: any = document.getElementsByClassName('alert')[0];
      if (divAlert) {
        gridHeight = gridHeight - divAlert.clientHeight - 10;
      }

      const warehouseSelectEl = document.querySelector('app-warehouse-select');
      if (warehouseSelectEl) {
        this.dxGridHeight = gridHeight + 'px';
      } else {
        this.dxGridHeight = (gridHeight + 70) + 'px';
      }
      // nếu cần thì mở dòng này
      // this.cdr.detectChanges();
    }, 10);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.initTableHeight();
  }

  setListOfAllData(listOfAllData: any[]) {
    this.listOfAllData = listOfAllData.map(item => {
      return Object.assign({}, item);
    });
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(value?: boolean, obj?: any, childrenName?: string): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item[this.prop]]);
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item[this.prop]]) &&
      !this.isAllDisplayDataChecked;
    this.numberOfChecked = this.listOfAllData.filter(item => this.mapOfCheckedId[item[this.prop]]).length;
    if (value !== undefined && obj !== undefined && childrenName !== undefined) {
      this.setChildrenStatus(value, obj, childrenName);
    }
  }

  setChildrenStatus(value: boolean, obj: any, childrenName: string) {
    if (obj[childrenName] !== null && obj[childrenName].length > 0) {
      for (const child of obj[childrenName]) {
        this.mapOfCheckedId[child[this.prop]] = value;
        this.setChildrenStatus(value, child, childrenName);
      }
    }
    return;
  }

  checkAllRow(value: boolean, childrenName?: string): void {
    this.listOfDisplayData.forEach(item => {
        if (item.isDisabled === false || item.isDisabled == null) {
          this.mapOfCheckedId[item[this.prop]] = value;
          if (childrenName !== undefined) {
            this.setChildrenStatus(value, item, childrenName);
          }
        }
      }
    );
    this.refreshStatus();
  }

  checkAll(value: boolean): void {
    // tslint:disable-next-line:max-line-length
    this.listOfAllData.filter(item => item.status !== 2 && item.status !== 3)
      .forEach(item => (this.mapOfCheckedId[item[this.prop]] = value));
    this.refreshStatus();
  }

  getCheckedIdList(searchText?: string, searchData?: any[]): number[] {
    const listIds = [];
    let isChecked = false;

    Object.keys(this.mapOfCheckedId).forEach(key => {
      if (this.mapOfCheckedId[key]) {
        listIds.push(Number(key));
        isChecked = true;
      }
    });

    if (searchData !== undefined
      && searchText !== undefined
      && (searchText.trim()).length > 0
      && !isChecked
    ) {
      searchData.forEach(item => {
        listIds.push(item[this.prop]);
      });
    }
    return listIds;
  }

}
